<div class="container">
    <div class="page-title-content">
        <h2 class="titulo-login">
            <a routerLink="/home"><img src="assets/img/logos uoetsylra/logo sindicato.png"
                     alt="logo uoetsylra"
                     width="50%"></a>
        </h2>
    </div>
</div>

<div class="profile-authentication-area">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="register-form">
                    <h2>Registro</h2>

                    <div class="info">
                        <div class="info-step mb-3">
                            <span class="step-badge">Paso 1</span>
                            <div class="step-desc">
                                <strong>Validación de Afiliado:</strong> Ingrese su número de <strong>D.N.I</strong>. El sistema buscará automáticamente si usted está registrado en el padrón. Si el sistema valida sus datos, podrá continuar rellenando el formulario.
                            </div>
                        </div>
                        <div class="info-step">
                            <span class="step-badge">Paso 2</span>
                            <div class="step-desc">
                                <strong>Activación de Cuenta:</strong> Una vez completado el registro, recibirá un correo electrónico con un <strong>PIN de validación</strong>. Deberá presionar el enlace que reciba para activar su cuenta y poder iniciar sesión.
                            </div>
                        </div>
                    </div>

                    <form [formGroup]="registerForm"
                          (ngSubmit)="registerUser()">

                        <div class="row">
                            <div class="col">
                                <div class="box-input-shadow-dni">
                                    <div class="form-group inner-addon right-addon">
                                        <label>Número de Identificación - D.N.I</label>
                                        <div class="input-group">
                                            <input type="text"
                                                   formControlName="identificacion"
                                                   class="form-control"
                                                   (paste)="$event.preventDefault()"
                                                   placeholder="número de D.N.I"
                                                   [class.is-invalid]="getIdentificacionNoValida">
                                            <div *ngIf="viewSpinner"
                                                 class="loader-container">
                                                <strong>Buscando Afiliado...</strong>
                                                <i class="loader"></i>
                                            </div>
                                            </div>
                                        <mat-error *ngIf="getIdentificacionNoValida">Número de Identificación - D.N.I</mat-error>
                                        <br>
                                        <div *ngIf="showTimeoutMessage && !flagDataEncontrada"
                                             class="text-danger">
                                            No se han encontrado sus datos de afiliado. Por favor, verifique el DNI ingresado.
                                            Si aún tiene problemas, contacte con soporte.
                                        </div>
                                        <div *ngIf="flagDataEncontrada && !viewSpinner"
                                             class="dni-found-alert">
                                            <i class="fas fa-check-circle"></i>
                                            <span>¡Afiliado encontrado! Sus datos fueron completados. Verifique y complete el resto de los campos para finalizar el registro.</span>
                                        </div>
                                        </div>
                                </div>
        
                                <div class="form-group">
                                    <div class="row mb-4">
                                        <div class="col-lg-6 col-xs-12">
                                            <div class="form-outline">
                                                <label>Escriba su nombre completo</label>
                                                <input type="text"
                                                       formControlName="nombrePersona"
                                                       placeholder="nombre completo"
                                                       [class.is-invalid]="getNombreNoValido"
                                                       class="form-control"
                                                       style="margin-right: 3px;">
                                                <small style="margin-right: 30px;"
                                                       *ngIf="getNombreNoValido"
                                                       class="text-danger">Escriba su nombre completo</small>
                                            </div>
                                        </div>
        
                                        <div class="col-lg-6 col-xs-12">
                                            <div class="form-outline">
                                                <label>Escriba su apellido completo</label>
                                                <input type="text"
                                                       formControlName="apellidoPersona"
                                                       placeholder="apellido"
                                                       [class.is-invalid]="getApellidoNoValido"
                                                       class="form-control">
                                                <small *ngIf="getApellidoNoValido"
                                                       class="text-danger">Escriba su apellido completo</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="form-group">
                                    <label>Correo electrónico</label>
                                    <input formControlName="email"
                                           type="email"
                                           class="form-control text-lowercase"
                                           placeholder="Ingrese su correo electrónico"
                                           [class.is-invalid]="emailNoValido">
                                    <small *ngIf="emailNoValido"
                                           class="text-danger">Ingrese un correo electrónico válido</small>
                                </div>
                                <div class="form-group">
                                    <label>Confirme su correo electrónico</label>
                                    <input formControlName="confirmEmail"
                                           type="email"
                                           class="form-control text-lowercase"
                                           placeholder="Confirme su correo electrónico"
                                           [class.is-invalid]="confirmEmailNoValido">
                                    <small *ngIf="confirmEmailNoValido"
                                           class="text-danger">Los correos electrónicos no coinciden</small>
                                </div>

                                <div class="form-group">
                                    <label>Teléfono (WhatsApp)</label>
                                    <input formControlName="telefono"
                                           type="tel"
                                           class="form-control"
                                           placeholder="Ej: +54 11 1234 5678"
                                           [class.is-invalid]="getTelefonoNoValido">
                                    <small *ngIf="getTelefonoNoValido"
                                           class="text-danger">Ingrese un teléfono de WhatsApp válido</small>
                                </div>
                            </div>
    
                            <div class="col">
                                <div class="form-group inner-addon right-addon">
                                    <label>Contraseña</label>
                                    <div class="input-group">
                                        <input formControlName="password"
                                               [type]="showPasswordRegister ? 'text' : 'password'"
                                               class="form-control"
                                               placeholder="Ingrese su contraseña"
                                               [class.is-invalid]="passwordNoValido"
                                               (cut)="$event.preventDefault()"
                                               (copy)="$event.preventDefault()"
                                               (paste)="$event.preventDefault()">
                                        <i alt="show"
                                           class="far fa-eye eye-show"
                                           (click)="showPasswordRegister = !showPasswordRegister"
                                           [class.hide]="showPasswordRegister"></i>
                                        <i alt="hide"
                                           class="far fa-eye-slash eye-hide"
                                           (click)="showPasswordRegister = !showPasswordRegister"
                                           [class.hide]="!showPasswordRegister"></i><br>
                                    </div>
                                    <small *ngIf="passwordNoValido" class="text-danger">
                                        Por favor, elija una contraseña que cumpla con los siguientes requisitos:<br>
                                        - Debe tener 8 caracteres de longitud.<br>
                                        ¡Gracias!
                                    </small>                                                   
                                </div>
        
                                <div class="form-group inner-addon right-addon">
                                    <label>Confirme su contraseña</label>
                                    <div class="input-group">
                                        <input formControlName="confirmPassword"
                                               [type]="showPasswordConfirm ? 'text' : 'password'"
                                               class="form-control"
                                               placeholder="Confirme su contraseña"
                                               [class.is-invalid]="confirmPasswordNoValido">
                                        <i alt="show"
                                           class="far fa-eye eye-show"
                                           (click)="showPasswordConfirm = !showPasswordConfirm"
                                           [class.hide]="showPasswordConfirm"></i>
                                        <i alt="hide"
                                           class="far fa-eye-slash eye-hide"
                                           (click)="showPasswordConfirm = !showPasswordConfirm"
                                           [class.hide]="!showPasswordConfirm"></i><br>
                                    </div>
                                    <small *ngIf="confirmPasswordNoValido" class="text-danger">
                                        Por favor, asegúrese que las contraseñas coincidan.
                                    </small>
                                    
                                </div>
        
                                <p class="description">
                                    Por favor, elija una contraseña que cumpla con los siguientes requisitos:
                                    - Debe tener al menos 8 caracteres de longitud. ¡Gracias!
                                </p>
                                
        
                                <div class="form-group">
                                    <input type="checkbox"
                                           formControlName="proteccionDeDatos"
                                           style="margin-right: 5px !important;"> <em>He leído y acepto la cláusula de Información sobre Protección de Datos
                                        - <a href="https://beneficios.uoetsylra.cipbyte.io/politica_de_privacidad/politica_de_privacidad.html" target="_blank"
                                           class="link"
                                           style="text-decoration: none;">Cláusula Registro</a></em>
                                </div>
        
                                <div class="form-group">
                                    <input type="checkbox"
                                           formControlName="clausula"
                                           style="margin-right: 5px !important;"> <em>Autorizo al tratamiento de mis datos para poder recibir información por medios electrónicos</em>
                                </div>
        
                                <div class="form-group">
                                    <input type="checkbox"
                                           formControlName="aceptaTerminos"
                                           style="margin-right: 5px !important;"> <em>He leído y acepto los Términos y Condiciones
                                        - <a href="https://beneficios.uoetsylra.cipbyte.io/politica_de_privacidad/terminos-y-condiciones.html" target="_blank"
                                           class="link"
                                           style="text-decoration: none;">Términos y condiciones</a></em>
                                </div>
        
                                <div class="form-group">
                                    <ngx-recaptcha2 #captchaElem
                                                    [siteKey]="siteKey"
                                                    formControlName="recaptcha">
                                    </ngx-recaptcha2>
                                </div>
        
                                </div>

                            <div class="col-12 text-center mt-3">
                                <button [disabled]="!flagFormaValido"
                                        [ngClass]="{'custom-disabled': !flagFormaValido}"
                                        type="submit"> Registrarme</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>